import { EntidadeBase } from 'hay-core-react';
class EmailEnvioModel extends EntidadeBase {
    constructor() { super('emailenvio'); }
}

const instance = new EmailEnvioModel();
export default instance;
